import { render, staticRenderFns } from "./V2PriceUpdateWarning.vue?vue&type=template&id=b976f3ac&scoped=true&"
import script from "./V2PriceUpdateWarning.vue?vue&type=script&lang=js&"
export * from "./V2PriceUpdateWarning.vue?vue&type=script&lang=js&"
import style0 from "./V2PriceUpdateWarning.vue?vue&type=style&index=0&id=b976f3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b976f3ac",
  null
  
)

export default component.exports